<template>
  <div class="page-container">
    <div class="header">
      <div class="title">分账收款记录</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="120px"
        label-position="left">
        <el-row>
          <el-col :span="8">
            <el-form-item label="收款时间" size="small">
              <el-date-picker
                v-model="dateTimeRange"
                :picker-options="pickerOptions"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商户号" size="small">
              <el-input v-model="form.merchantId" placeholder="请输入商户号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分账批次号" size="small">
              <el-input v-model="form.splitBatchNo" placeholder="请输入分账批次号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item size="small">
              <el-button type="primary" @click="handleFormSearch" class="bs-btn" :loading="table.loading">查询</el-button>
              <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
              <el-button @click="exportTable" class="bs-btn" :loading="exportLoading">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <p style="margin-bottom: 20px;">统计：总收款金额{{ sToFixed(table.sumAmount / 100) }}元</p>
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="innerTransferTime" label="收款时间" align="center" min-width="250px" />
        <el-table-column prop="splitBatchNo" label="分账批次号" align="center" min-width="150px" />
        <el-table-column prop="merchantId" label="付款方商编" align="center" min-width="150px" />
        <el-table-column prop="merchantName" label="付款方商户名称" align="center" min-width="150px" />
        <el-table-column prop="amount" label="应收款金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.amount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="actualAmount" label="实际到账金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.actualAmount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="fee" label="手续费" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.fee / 100) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="分账状态" align="center" min-width="150px">
          <template slot-scope="{row}">{{ statusMap[row.status] || '' }}</template>
        </el-table-column>
        <el-table-column prop="pageRemark" label="备注标记" align="center" min-width="150px" />
        <el-table-column label="操作" align="center" min-width="80px">
          <template slot-scope="{row}">
            <el-button type="text" @click="openDetailDialog(row)">详情</el-button>
            <el-button type="text" @click="openRemarkDialog(row)">备注</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="showDetailDialog" width="500px" center>
      <div class="detail-form-container">
        <el-form label-width="100px" label-position="left" class="detail-form">
          <el-form-item label="余额变动单号">
            <span id="flowId">{{ detailForm.flowId || '-' }}</span>
            <copy-btn v-if="detailForm.flowId" id="#flowId" />
          </el-form-item>
          <el-form-item label="变动时间">{{ detailForm.createTime || '-' }}</el-form-item>
          <el-form-item label="交易类型">{{ businessTypeMap[detailForm.businessType] || '-' }}</el-form-item>
          <el-form-item label="收支类型">{{ detailForm.operateType === 0 ? '出账' : '入账' }}</el-form-item>
          <el-form-item label="变动金额">{{ sToFixed(detailForm.amount / 100) }}</el-form-item>
          <el-form-item label="变动前余额">{{ sToFixed(detailForm.beforeBalance / 100) }}</el-form-item>
          <el-form-item label="变动后余额">{{ sToFixed(detailForm.balance / 100) }}</el-form-item>
          <el-form-item label="交易状态">{{ statusMap[detailForm.status] || '' }}</el-form-item>
          <div class="detail-form-title">原业务单据</div>
          <el-form-item label="业务类型">{{ oriBusinessTypeMap[detailForm.oriBusinessType] || '-' }}</el-form-item>
          <el-form-item label="业务流水号">
            <span id="oriBusinessNo">{{ detailForm.oriBusinessNo || '-' }}</span>
            <copy-btn v-if="detailForm.oriBusinessNo" id="#oriBusinessNo" />
          </el-form-item>
          <div class="detail-form-title">分账账户信息</div>
          <el-form-item label="接收方账户">{{ detailForm.receiveMerchantName }}(ID:{{ detailForm.receiveMerchantId }})</el-form-item>
          <el-form-item label="银行卡号">{{ detailForm.bankAccountNo }}({{ detailForm.bankName }})</el-form-item>
          <el-form-item label="分账场景">{{ splitAccountSceneMap[detailForm.splitAccountScene] || '-' }}</el-form-item>
          <el-form-item label="分账方打款备注">{{ detailForm.remark }}</el-form-item>
          <div class="detail-form-title">分账明细</div>
          <el-form-item label="分账批次号">
            <span id="splitBatchNo">{{ detailForm.splitBatchNo || '-' }}</span>
            <copy-btn v-if="detailForm.splitBatchNo" id="#splitBatchNo" />
          </el-form-item>
          <el-form-item label="分账金额">{{ sToFixed(detailForm.splitAmount / 100) }}</el-form-item>
          <el-form-item label="分账手续费">{{ sToFixed(detailForm.fee / 100) }}</el-form-item>
          <el-form-item label="备注">{{ detailForm.pageRemark }}</el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="showRemarkDialog" width="500px" center>
      <div class="detail-form-container">
        <el-form label-width="100px" label-position="left" class="detail-form">
          <el-form-item label="收款备注">
            <el-input v-model="remarkForm.pageRemark" :rows="3" :maxlength="100" resize="none" type="textarea" placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRemarkDialog = false">取消</el-button>
        <el-button class="bs-btn" type="primary" :loading="confirmLoading" @click="handleConfirmRemark">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// copilot begin
import moment from "moment";
import { debounce, sToFixed } from "@/utils/index";
import {
  downloadSplitAccountReceiveRecord, querySplitAccountReceiveRecord, querySplitAccountReceiveDetail, updateFlowRelatedPageRemark,
} from "../../../api/cloud-manage";
import CopyBtn from '@/components/CopyBtn/copy-btn.vue';

export default {
  name: "split-collection-records",
  components: {
    CopyBtn,
  },
  data() {
    const FORMAT = 'yyyy-MM-DD HH:mm:ss';
    const today = moment().endOf('day').format(FORMAT);
    const sixMonthBefore = moment().subtract(6, 'months').startOf('day').format(FORMAT);
    const businessTypeMap = {
      1: '充值',
      2: '充值撤销',
      3: '消费',
      4: '消费撤销',
      5: '转账',
      6: '转账撤销',
      7: '提现',
      8: '提现撤销',
    };
    return {
      statusMap: {
        0: '初始',
        1: '成功',
        2: '失败',
        3: '划转中',
      },
      businessTypeMap,
      oriBusinessTypeMap: {
        ...businessTypeMap,
        9: '调账',
        10: '调账撤销',
        11: '钱包手动提现',
        12: '钱包自动提现',
        13: '转账手续费',
        14: '提现手续费',
      },
      splitAccountSceneMap: {
        1001: 'B2C电商平台',
        1002: 'O2O电商服务平台',
        1003: '共享租赁',
        1004: '知识付费/内容分成',
        1005: '多方合作营销',
        1006: '供应链/连锁经营',
      },
      pickDate: null,
      dateTimeRange: [sixMonthBefore, today],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickDate = (minDate && !maxDate) ? minDate : null;
        },
        disabledDate: (time) => {
          if (this.pickDate) {
            const mPickDate = moment(this.pickDate);
            return (moment(time).isBefore(moment(mPickDate).subtract(6, 'months')) || moment(time).isAfter(moment(mPickDate).add(6, 'months')));
          }
          return false;
        },
      },
      form: {
        splitBatchNo: '',
        merchantId: '',
      },
      exportLoading: false,
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        sumAmount: 0,
        totalCount: 0,
        pageSize: 10,
      },
      showDetailDialog: false,
      showRemarkDialog: false,
      confirmLoading: false,
      detailForm: {},
      remarkForm: {
        id: '',
        pageRemark: '',
      },
    };
  },
  computed: {
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
  },
  mounted() {
    this.handleFormSearch();
  },
  methods: {
    sToFixed,
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        splitBatchNo: '',
        merchantId: '',
      };
      this.dateTimeRange = [];
      this.handleFormSearch();
    },
    exportTableFunc() {
      const [innerTransferStartTime, innerTransferEndTime] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        innerTransferStartTime,
        innerTransferEndTime,
      };
      this.exportLoading = true;
      downloadSplitAccountReceiveRecord(params).then(({ data: { code } }) => {
        if (code === '0') {
          this.$message.success('导出成功，请到下载中心下载报表文件！');
        }
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    async queryTableData() {
      const { pageNo, pageSize } = this.table;
      const [innerTransferStartTime, innerTransferEndTime] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        pageNo,
        pageSize,
        innerTransferStartTime,
        innerTransferEndTime,
      };
      this.table.loading = true;
      const { data: { data: { list = [], totalCount = 0, sumAmount = 0 } } } = await querySplitAccountReceiveRecord(params).finally(() => {
        this.table.loading = false;
      });
      this.table.data = list;
      this.table.totalCount = totalCount;
      this.table.sumAmount = sumAmount;
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    openDetailDialog({ splitSerialNo, splitRelateId }) {
      querySplitAccountReceiveDetail({ splitSerialNo, splitRelateId }).then(({ data: { data } }) => {
        this.detailForm = { ...data };
        this.showDetailDialog = true;
      });
    },
    openRemarkDialog({ splitRelateId, pageRemark }) {
      this.remarkForm.id = splitRelateId;
      this.remarkForm.pageRemark = pageRemark;
      this.showRemarkDialog = true;
    },
    handleConfirmRemark() {
      this.confirmLoading = true;
      updateFlowRelatedPageRemark(this.remarkForm).then(({ data: { data } }) => {
        if (data) {
          this.$message.success('备注更新成功');
          this.showRemarkDialog = false;
          this.queryTableData();
        } else {
          this.$message.error('备注更新失败');
        }
      }).finally(() => {
        this.confirmLoading = false;
      });
    },
  },
};
// copilot end
</script>
<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .detail-form-container {
    padding: 0 20px;

    /deep/ .el-form-item__label {
      font-weight: normal;
      color: #666;
    }

    /deep/ .el-form-item__content {
      color: #333;
      text-align: right;
    }

    /deep/ .el-form-item {
      margin-bottom: 0;
    }

    .detail-form-title {
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
